var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{class:`${_vm.importedDataStyling}`,attrs:{"readonly":_vm.readOnlyInputs},on:{"change":_vm.onChangeInput},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }